export enum StationType {
  POI = 101,
  IMPRINT = 102,
  TIPP = 103,
  ABOUT = 104,
  QUESTION = 501,
  LEXICON_ENTRY = 201,
  CONTACT = 301,
  CONTACT_CATEGORY = 311,
  TEMPLATE = 401
}

